'use client'

import { NewsLetterIcon } from '@/svgs'
import { toastError, toastSuccess } from '@/utils/toaster'
import React, { useState, useEffect } from 'react'
// import 'toastify-js/src/toastify.css'

export default function NewsLetter() {
   const [email, setEmail] = useState('')
   const [isValidEmail, setIsValidEmail] = useState(false)

   const validateEmail = (value) => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      setIsValidEmail(regex.test(value))
   }

   const handleChange = (e) => {
      const value = e.target.value
      setEmail(value)
      validateEmail(value)
   }

   const handleSubscribeClick = async () => {
      try {
         const response = await fetch(
            // NEXT_PUBLIC_BACKEND_URL
            `${process.env.NEXT_PUBLIC_BACKEND_URL}/subscriber-mail/subscribe`,
            {
               method: 'POST',
               headers: {
                  'Content-Type': 'application/json',
               },
               body: JSON.stringify({ email }),
            }
         )

         const result = await response.json()

         if (!response.ok) {
            const errorText =
               response.status === 429
                  ? 'Too many requests. Retrying after some time!'
                  : 'Something went wrong!. Please try again!'

             toastError(errorText)
            return
         }

         toastSuccess(result?.msg)
         setEmail('')
      } catch (error) {
         toastError("There was an error in subscribing to news letter!. Please try again!")
      }
   }

   return (
      <section className="newsLetter">
         <div className="container">
            <div className="gap-3 d-flex justify-content-xl-between justify-content-center">
               <div className="d-xl-block d-none">
                  <NewsLetterIcon />
               </div>
               <div className="align-content-center">
                  <h1 className="news-title text-start">
                     Subscribe to Our Newsletter
                  </h1>
                  <p className="info_tell_description mb-4 text-start news-desc">
                     Stay ahead in the digital world with exclusive updates from
                     Benzatine Infotech! Get the latest tech trends, deep
                     insights, and innovative business ideas delivered straight
                     to you. Subscribe now for cutting-edge updates that keep
                     you ahead of the competition!
                  </p>
                  <div className="news-rounded-parent gap-2">
                     <div className="d-flex gap-1 align-items-center col-xl-7 col-sm-8 col-12">
                        <div className="mail-news col-4">
                           <svg
                              width="27"
                              height="27"
                              viewBox="0 0 27 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              xlink="http://www.w3.org/1999/xlink"
                           >
                              <path
                                 d="M0.599609 26.0342H26.5996V0.0341797H0.599609V26.0342Z"
                                 fill="url(#pattern0_2209_23055)"
                              />
                              <defs>
                                 <pattern
                                    id="pattern0_2209_23055"
                                    patternContentUnits="objectBoundingBox"
                                    width="1"
                                    height="1"
                                 >
                                    <use
                                       href="#image0_2209_23055"
                                       transform="scale(0.015625)"
                                    />
                                 </pattern>
                                 <image
                                    id="image0_2209_23055"
                                    width="64"
                                    height="64"
                                    preserveAspectRatio="none"
                                    href="data:image/png;base64,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"
                                 />
                              </defs>
                           </svg>
                        </div>
                        <input
                           className="email-text"
                           type="text"
                           placeholder="Enter your email address"
                           value={email}
                           onChange={handleChange}
                        />
                     </div>
                     <div
                        className={`news-subscribe d-none d-sm-block col-4 ${
                           isValidEmail ? 'subs-btn' : ''
                        }`}
                        id="subscribeDiv"
                        onClick={isValidEmail ? handleSubscribeClick : null}
                     >
                        Subscribe
                     </div>
                  </div>
                  <div className="mt-3 nbs">
                     <div
                        className={`news-subscribe ${
                           isValidEmail ? 'subs-btn2' : ''
                        }`}
                        id="subscribeDiv2"
                        onClick={isValidEmail ? handleSubscribeClick : null}
                     >
                        Subscribe
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}
